import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/reckncase/conc-back.webp";

function Whatmob() {
  return (
    <section
      className="what_mob conc_reck p-100 text_reck"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "bottom center",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              <span>Conclusion</span> 
            </h2>
            <p>
              The Reck’N mobile app is a testimony to TekRevol’s pledge to
              novelty and excellence. By transforming a new idea into a
              practical and impactful solution, TekRevol connected the gap
              between restaurants and customers, uplifting the dining experience
              to new dimensions.
            </p>
            <p>
              With features that streamline bookings, improve socialization, and
              increase restaurant sales, Reck’N is more than an app—it's a
              revolution in how we dine and connect.
            </p>
            <div className="what_mob_img_reck mt-4">
              <StaticImage
                src="../../../images/case-studies/reckncase/conclusion.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={779}
                height={571}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whatmob;
